module.exports = __webpack_public_path__ + "img/01.7252f694.jpg";